import { reactive } from "vue";

export const globalState = reactive({
  modal: {
    isOpen: false,
    toolId: null,
    categories: [],
  },

  requestModal: {
    isOpen: false,
    requestId: null,
    categories: [],
  },

  openModal(toolId, categories) {
    this.modal.toolId = toolId;
    this.modal.isOpen = true;
    this.modal.categories = categories;
    // Disable body scroll when modal is open
    document.body.style.overflow = "hidden";
  },

  closeModal() {
    this.modal.isOpen = false;
    this.modal.toolId = null;
    this.modal.categories = [];
    // Enable body scroll
    document.body.style.overflow = "";
  },

  openRequestModal(requestId, categories) {
    this.requestModal.requestId = requestId;
    this.requestModal.isOpen = true;
    this.requestModal.categories = categories;
    document.body.style.overflow = "hidden";
  },

  closeRequestModal() {
    this.requestModal.isOpen = false;
    this.requestModal.requestId = null;
    this.requestModal.categories = [];
    document.body.style.overflow = "";
  },

  // 小义问宝（AI 问答）
  askBot: {
    isOpen: false,
    question: "",
  },

  openAskBot(question) {
    this.askBot.question = question || "";
    this.askBot.isOpen = true;
    document.body.style.overflow = "hidden";
  },

  closeAskBot() {
    this.askBot.isOpen = false;
    this.askBot.question = "";
    document.body.style.overflow = "";
  },
});
